import { PARAMS_COOKIE_KEYS } from 'Consts/cookies.enum'
import { CookieHelper } from './cookieHelper'
import { isExcludedEmail } from './excludeTestAccounts'

const { getLogicCookieData } = CookieHelper()

export const getAppcuesId = (email: string | undefined, userId?: number) => {
  const { REACT_APP_ENVIRONMENT } = process.env
  const id = userId || getLogicCookieData(PARAMS_COOKIE_KEYS.USER_ID)
  const isTestAccount = (email && isExcludedEmail(email)) || REACT_APP_ENVIRONMENT !== 'production'

  return `${REACT_APP_ENVIRONMENT || ''}${isTestAccount ? '_test' : ''}_${id}`
}
